import {FC} from 'react';

import {Box, DialogActions, DialogContent, DialogTitle, IconButton, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';

import CloseOutlinedIcon from 'assets/icons/closedOutlinedIcon';
import Button from 'components/button/Button';
import SendBrowserEvent from 'services/send-browser-event';
import {setVariantIdsOfItemThatWasAdjustedQuantityAction} from 'store/actions/basket-action';

import {StyledDialog} from './styles';
import ExpressPicture from '../../assets/images/express-picture.png';

export interface ExpressModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ExpressModal: FC<ExpressModalProps> = ({onClose, isOpen}) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const onBackToHome = () => {
    SendBrowserEvent.closeBasketDrawer();
    dispatch(setVariantIdsOfItemThatWasAdjustedQuantityAction([]));
    onClose();
  };

  return (
    <StyledDialog open={isOpen} onClose={onClose}>
      <DialogTitle>
        <IconButton onClick={onClose}>
          <CloseOutlinedIcon color="secondary" fontSize="medium" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
          <Box component="img" width={160} height={160} src={ExpressPicture}></Box>
        </Box>
        <Typography textAlign="center" fontSize={20} fontWeight={700}>
          {t('express.title.whyAddressNotSupported')}
        </Typography>
        <Typography textAlign="center" fontSize={16} whiteSpace="pre-line">
          {t('express.message.unsupportedAddressModalMessage')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button shape="rounded" variant="outlined" fullWidth onClick={onBackToHome}>
          {t('express.label.backToHome')}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};
